import * as types from "../actions/actionTypes";
import { getAllDesignVersionsResponse, getDesignVersionByIdResponse } from "../actions";
import { createEntitySagas } from "./sagaHelpers";

export const designversionEntity = createEntitySagas({
  entity: "designversion",
  endpoint: "design-versions",
  label: "Design version",
  scope: "none",
  requiredParam: "designId",
  selectSlice: (state) => state.designversion,
  listKey: "versions",
  types: {
    getAll: types.GET_ALL_DESIGN_VERSIONS,
    getById: types.GET_DESIGN_VERSION_BY_ID,
    create: types.CREATE_DESIGN_VERSION,
    update: types.UPDATE_DESIGN_VERSION,
    remove: types.DELETE_DESIGN_VERSION,
  },
  actions: { getAllResponse: getAllDesignVersionsResponse, getByIdResponse: getDesignVersionByIdResponse },
});

export const designversionSaga = designversionEntity.watcher;
